export const BQ_CLICKED_PACKAGE_SELECT = 'clicked_package_select';
export const BQ_CLICKED_CUSTOM_ORDER = 'gig_page.click_on_get_quote';
export const BQ_CLICKED_REPORT_GIG = 'gig_report.click';
export const BQ_GIG_DESCRIPTION_SEE_MORE = 'clicked_on_see_more_gig_description';
export const BQ_CLICKED_CONTACT_SELLER = 'clicked_on_contact_seller';
export const BQ_CLICKED_PACKAGES_TAB = 'clicked_on_packages_tab';
export const BQ_CLICKED_REVIEWS_SNIPPET_MORE = 'clicked_on_show_more';
export const BQ_OPEN_COUPON_ARTICLE = 'clicked_on_learn_more_about_coupons';
export const BQ_SEEN_BOMBA_COUPON = 'learn_more_about_coupons_bomba_is_shown';
export const BQ_SELLER_BUYER_SPEAK_SAME_LANGUAGE = 'seller_and_buyer_speak_the_same_language';
export const BQ_CLICKED_GALLERY_VIDEO = 'video_play';
export const BQ_CLICKED_SELLER_LINK = 'clicked_on_seller_name_gig_page';
export const BQ_CLICKED_SELLER_NAME_ANCHOR = 'clicked_on_seller_icon_gig_page';
export const BQ_CLICKED_TOPNAV = 'clicked_on_top_bar_gig_page';
export const BQ_CLICKED_REVIEWS_RATINGS = 'clicked_on_ratings_stars_gig_page';
export const BQ_PAGE_TRANSLATED_BY_EXTENSION = 'page_translated_by_extension';
export const BQ_GIG_DESCRIPTION_IMPRESSION = 'gig_page_gig_description';
export const BQ_STICKY_EXPERIENCE = 'mt_sticky_experience';
export const BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS = 'clicked_on_contact_seller_options';
export const BQ_SIGNUP_CLICK = 'signup_click';
